import ProjectedProfitPageContainer from './containers/ProjectedProfitPageContainer'

export default ProjectedProfitPageContainer
